
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.556 11.777L2.334 9.111c-.607-.486-.34-1.464.43-1.574l4.57-.204 1.95-4.891a.8.8 0 011.431 0l1.952 4.891 4.568.204c.772.11 1.038 1.088.43 1.574l-3.22 2.666.878 5.207a.889.889 0 01-1.277.92L10 15.333l-4.046 2.57a.889.889 0 01-1.277-.92l.879-5.206z","fill":"currentColor","stroke":"currentColor"}})])
          )
        }
      }
    